import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GlobalVariablesService {
  private baseUrl = `${environment.apiUrl}/api/admin/global-variables`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<Record<string, string>> {
    return this.http.get<Record<string, string>>(this.baseUrl);
  }

  saveAll(data: Record<string, string>): Observable<any> {
    return this.http.put(this.baseUrl, data);
  }
}
